var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader d-flex justify-content-center"},[_c('b-spinner',{staticClass:"spinnar-top",attrs:{"variant":_vm.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }